import React from 'react';

import classNames from 'classnames';
import * as css from './BottomLink.scss';

const BottomLink = () => {
	return (
		<a
			className={css.link}
			href="https://www.mako.co.il/help-5bb6bf4ccf39c110/Article-b7ff18a9de86471026.htm"
			rel="noreferrer"
			target="_blank"
		>
			הסדרי נגישות
		</a>
	);
};

export { BottomLink };
